import React, { useRef, useState } from 'react';
import ReactPlayer from 'react-player';

import './reel-player.scss';

import ReelNoPreview from '../../../../../../images/StoriesNoPreview.png';
import { formatTime, getPlatformFromUrl } from '../../../../../../utils/global';
import PauseIcon from '../../../../../Icons/icons/PlayerIcon/PauseIcon';
import PlayIcon from '../../../../../Icons/icons/PlayerIcon/PlayIcon';
import CardStats from '../CardStats';
import CardTopContent from '../CardTopContent';
import Controls from './Controls';

const ReelPlayer = ({ content, style }) => {
  const [playing, setPlaying] = useState(content?.thumbnail ? true : false);
  const [durationSeconds, setDurationSeconds] = useState(0);
  const [playedSeconds, setPlayedSeconds] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const [isMutated, setIsMutated] = useState(false);
  const playerRef = useRef();
  const [isErrorLoading, setIsErrorLoading] = useState(false);

  const media = content?.media?.[0];

  const handlePlayerClick = () => {
    if (!content?.thumbnail && !playing && !loaded) {
      setPlaying(true);
    }
  };

  return (
    <div className="player-container reel-player">
      <div className="gradient-overlay-top" />
      <div className="gradient-overlay-bottom" />
      <div className="top-container">
        <CardTopContent
          profile={content?.profile}
          downloadUrl={content.media?.[0]?.url}
          entityUrl={content?.entityUrl}
        />
      </div>
      {isErrorLoading || !media?.url?.length ? (
        <img src={content?.thumbnail || ReelNoPreview} alt="No Preview" className="no-preview-image" />
      ) : (
        <div onClick={handlePlayerClick} className="player-wrapper">
          <ReactPlayer
            width="100%"
            height="100%"
            url={media?.url}
            className="react-player"
            ref={playerRef}
            controls={false}
            playing={playing}
            onProgress={({ playedSeconds, loaded, played }) => {
              setPlayedSeconds(playedSeconds);
            }}
            onSeek={setPlayedSeconds}
            onDuration={setDurationSeconds}
            muted={isMutated}
            style={{
              ...style,
            }}
            onStart={() => setLoaded(true)}
            light={content.thumbnail}
            playIcon={
              <div className="play-icon-solid">
                <PlayIcon />
              </div>
            }
            onError={() => setIsErrorLoading(true)}
          />
        </div>
      )}
      {playedSeconds > 0 ||
        (!content?.thumbnail && (
          <div className="center-container" onClick={() => setPlaying((p) => !p)}>
            <div className="play-icon">{!playing ? <PlayIcon /> : <PauseIcon />}</div>
          </div>
        ))}

      {/* {!loaded && (
        <div className="before-play-duration">
          {formatTime(durationSeconds)}
        </div>
      )} */}

      <div className="bottom-container">
        {!isErrorLoading && loaded && (
          <Controls
            playerRef={playerRef}
            playing={playing}
            setPlaying={setPlaying}
            playedSeconds={playedSeconds}
            duration={durationSeconds}
            isMutated={isMutated}
            setIsMutated={setIsMutated}
          />
        )}
        <CardStats
          comments={content?.comments}
          likes={content?.likes}
          saves={content?.saves}
          shares={content?.shares}
          views={content?.views}
          type={content?.type}
          post={content}
        />
      </div>
    </div>
  );
};

export default ReelPlayer;
